module.exports = __webpack_public_path__ + "afcf5577f4bb10042d39a2a00d1971e8.svg";